module.exports = __webpack_public_path__ + "img/car-type.7db6b93a.svg";